import { render, staticRenderFns } from "./GlobalDetails.vue?vue&type=template&id=3411159f&scoped=true&"
import script from "./GlobalDetails.vue?vue&type=script&lang=js&"
export * from "./GlobalDetails.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDetails.vue?vue&type=style&index=0&id=3411159f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3411159f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3411159f')) {
      api.createRecord('3411159f', component.options)
    } else {
      api.reload('3411159f', component.options)
    }
    module.hot.accept("./GlobalDetails.vue?vue&type=template&id=3411159f&scoped=true&", function () {
      api.rerender('3411159f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalDetails.vue"
export default component.exports